import React from "react";

// File pentru formulare lungi. Conținutul fiecărei file rămâne montat (câmpurile păstrează valorile);
// paginile ascund filele inactive cu `style={tabStyle(activ, id)}` pe un element `display: contents`,
// ca grila formularului să rămână aceeași.
export function tabStyle(active, id) {
  return { display: active === id ? "contents" : "none" };
}

// tabs: [{ id, label, warn? }] — `warn` pune un punct roșu (câmp obligatoriu necompletat în filă).
export default function FormTabs({ tabs, value, onChange }) {
  return (
    <div className="form-tabs" role="tablist">
      {tabs.filter(t => !t.hidden).map(t => (
        <button key={t.id} type="button" role="tab" aria-selected={value === t.id}
          className={`form-tab${value === t.id ? " active" : ""}`} onClick={() => onChange(t.id)} data-testid={`tab-${t.id}`}>
          {t.label}{t.warn && <span className="dot" title="Câmp obligatoriu necompletat" />}
        </button>
      ))}
    </div>
  );
}
